/**
 * Created by Alex on 12/18/2024.
 *
 * ------ maintenance history ------
 *
 */

import { ThreadEntry } from '../../tamalelibs/models/thread-entry.model';
import { QueryInfo } from '../../pages/research/research.view-model';

export class AppendEntitiesDialogOpenOptions {
    openType: AppendEntitiesDialogType;
    minimizable: boolean;
    selectedItems: ThreadEntry[];
    queryInfo: QueryInfo;
    threadListIDs: string;
    threadListTotalCount: number;
}

export enum AppendEntitiesDialogType {
    AppendEntities = 'Append Entity(s)',
    AppendAllEntities = 'Append All Entity(s)'
}